import cx from 'clsx';
import { Text } from '@paylink/constants';

import { Image } from '@shared/components/core';

import notFound from '@assets/images/notFound.png';

import styles from './PageNotFound.module.scss';

const PageNotFound = () => (
	<div className="d-flex flex-column justify-center items-center height100">
		<Image src={notFound} width={260} height={180} className="object-contain" />
		<h2 className={cx('mt4 dark3 mb1 bolder ', styles.header)}>
			{Text.ERROR_404}
		</h2>
		<h4 className="m0 bolder h2 grey6">{Text.PAGE_NOT_FOUND}</h4>
	</div>
);

export default PageNotFound;
